import axios from "../../../../../services/api";
import Axios, { AxiosResponse, CancelTokenSource } from "axios";
import { getEnv } from "../../../../../api";
import { PaginationParamProps } from "../../../../hooks";
import { AgentesSSEInterface, Status } from "../../../../interfaces";
export interface IAgentesSSEService {
  findAll: (
    params: PaginationParamProps,
    body: Record<string, any>,
    source?: { token: CancelTokenSource }
  ) => Promise<any>;

  getOptions: (opcoes: boolean) => Promise<any>;
  create: (body: AgentesSSEInterface) => Promise<any>;
  read: (id: string | number) => Promise<any>;
  findCPF: (cpf: string, editCpf: string) => Promise<any>;
  getUnidades: (
    codSebrae: string,
    CodigoUnidadeOrganizacional: number | null
  ) => Promise<any>;
  update: (body: AgentesSSEInterface) => Promise<any>;
  getPedants: (body: any, source?: any) => Promise<any>;
  findUF: (uf: string) => Promise<any>;
  delete: (id: { id: string | number }) => Promise<any>;
  updateStatus: ({ id, status }: { id: any; status: Status }) => Promise<any>;
}

export const AgentesSSEService: IAgentesSSEService = {
  findAll: async (params, body = {}, source) => {
    try {
      // @ts-ignore
      const response: AxiosResponse = await axios.post(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/nan/atendente/consultar`,
        body,
        {
          params,
          cancelToken: source?.token,
        }
      );
      return response.data;
    } catch (error: any) {
      if (Axios.isCancel(error)) {
        console.log("Requisição cancelada", error.message);
      } else {
        console.log(error.message);
        throw error;
      }
    }
  },

  getOptions: async (opcoes: boolean) => {
    try {
      // @ts-ignore
      const response = await axios.get(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/nan/atendente/opcoes?opcoes=${opcoes}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getUnidades: async (codSebrae, CodigoUnidadeOrganizacional) => {
    const params = { codSebrae, CodigoUnidadeOrganizacional };
    // @ts-ignore
    const response = await axios.get(
      `${await getEnv(
        "REACT_APP_URL_SERVICE"
      )}/v1/integracao/sas/unidade-organizacional`,
      { params }
    );
    return response.data;
  },

  getPedants: async (body = {}, source) => {
    try {
      // @ts-ignore
      const response = await axios.post(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/nan/atendente/buscar-pendentes`,
        body,
        {
          cancelToken: source?.token,
        }
      );
      return response.data;
    } catch (error: any) {
      if (Axios.isCancel(error)) {
        console.log("Requisição cancelada", error.message);
      } else {
        console.log(error.message);
        throw error;
      }
    }
  },

  findCPF: async (cpf, editCpf) => {
    try {
      // @ts-ignore
      const response = await axios.get(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/integracao/sas/pessoa-fisica?cpf=${cpf ?? editCpf}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (body) => {
    try {
      // @ts-ignore
      delete body.tipo;

      // @ts-ignore
      const response = await axios.post(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/nan/atendente`,
        body
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  read: async (id) => {
    try {
      if (!id) return;

      // @ts-ignore
      const response = await axios.get(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/nan/atendente/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (body) => {
    try {
      // @ts-ignore
      delete body.tipo;

      // @ts-ignore
      const response = await axios.put(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/nan/atendente`,
        body
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      // @ts-ignore
      const response = await axios.delete(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/nan/atendente/${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  findUF: async (uf) => {
    try {
      // @ts-ignore
      const response = await axios.get(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/ufs/sebrae/${uf}`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },

  updateStatus: async ({ id, status }) => {
    try {
      // @ts-ignore
      const response = await axios.put(
        `${await getEnv(
          "REACT_APP_URL_SERVICE"
        )}/v1/nan/atendente/alterar-status?idAtendente=${id}&status=${status}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
